export const enum ServiceCategoryTypes {
    DESIGN_DEVELOPMENT = 'design_development',
    SOURCING = 'sourcing',
    MANUFACTURING = 'manufacturing',
    PACKAGING_LABELING = 'packaging_labeling',
    RETURN_REDUCTION = 'return_reduction',
    LOGISTICS_SHIPPING = 'logistics_shipping',
    REPAIR = 'repair',
    RESALE = 'resale',
    UPCYCLING = 'upcycling',
    RECYCLE = 'recycle',
    TRACEABILITY = 'traceability',
    REPORTING = 'reporting',
    CERTIFICATION = 'certification',
}
